import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';

import FollowProjectActionQuery from './__generated__/FollowProjectActionQuery.graphql';
import { FollowProjectActionQuery as FollowProjectActionQueryType } from './__generated__/FollowProjectActionQuery.graphql';

export const followProjectResource: RouteResource<
	PreloadedQuery<FollowProjectActionQueryType, Record<string, unknown>>
> = createRelayResource<FollowProjectActionQueryType>({
	getQuery: (routerContext) => {
		const { key } = routerContext?.match?.params || {};
		return {
			query: FollowProjectActionQuery,
			variables: {
				key: key || '',
			},
		};
	},
});
